var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "sub-visual"
  }, [_vm.tit ? _c('div', {
    staticClass: "sub-visual-tit white--text"
  }, [_c('v-container', [_c('h2', {
    staticClass: "tit tit--lg"
  }, [_vm._v(_vm._s(_vm.tit))]), _vm.sc ? _c('p', {
    staticClass: "page-text page-text--lg mt-12 mt-lg-20"
  }, [_vm._v(_vm._s(_vm.sc))]) : _vm._e()])], 1) : _vm._e(), _c('div', {
    staticClass: "sub-visual-bg",
    style: 'background-image:url(' + _vm.bg + ');'
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }